/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 20, height = 21 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 20 21"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g id="location-dot" clipPath="url(#clip0)">
      <path
        id="Vector"
        d="M10 6.125C9.50272 6.125 9.02581 6.32254 8.67417 6.67417C8.32254 7.02581 8.125 7.50272 8.125 8C8.125 8.49728 8.32254 8.97419 8.67417 9.32583C9.02581 9.67746 9.50272 9.875 10 9.875C10.4973 9.875 10.9742 9.67746 11.3258 9.32583C11.6775 8.97419 11.875 8.49728 11.875 8C11.875 7.50272 11.6775 7.02581 11.3258 6.67417C10.9742 6.32254 10.4973 6.125 10 6.125Z"
        fill="#D6C7BA"
      />
      <path
        id="Vector_2"
        opacity="0.6"
        d="M10.9258 20C12.9297 17.4922 17.5 11.4141 17.5 8C17.5 3.85938 14.1406 0.5 10 0.5C5.85938 0.5 2.5 3.85938 2.5 8C2.5 11.4141 7.07031 17.4922 9.07422 20C9.55469 20.5977 10.4453 20.5977 10.9258 20ZM10 4.875C10.8288 4.875 11.6237 5.20424 12.2097 5.79029C12.7958 6.37634 13.125 7.1712 13.125 8C13.125 8.8288 12.7958 9.62366 12.2097 10.2097C11.6237 10.7958 10.8288 11.125 10 11.125C9.1712 11.125 8.37634 10.7958 7.79029 10.2097C7.20424 9.62366 6.875 8.8288 6.875 8C6.875 7.1712 7.20424 6.37634 7.79029 5.79029C8.37634 5.20424 9.1712 4.875 10 4.875Z"
        fill="#D6C7BA"
      />
    </g>
    <defs>
      <clipPath id="clip0">
        <rect width="20" height="20" fill="white" transform="translate(0 0.5)" />
      </clipPath>
    </defs>
  </svg>
);

export default SvgComponent;
